import {Chip} from '@ds/components';

import {INTERVAL_ITEMS} from '../../../constants';
import type {IntervalValue} from '../../../types';

type IntervalSelectorProps = {
  value: IntervalValue;
  onChange: (value: IntervalValue) => void;
};

const IntervalSelector: React.FC<IntervalSelectorProps> = ({value, onChange}) => {
  return (
    <div className="flex gap-2.5 overflow-x-auto">
      {INTERVAL_ITEMS.map((item) => (
        <Chip
          key={item.key}
          label={item.label}
          selected={value === item.key}
          interactive
          onClick={() => onChange(item.key)}
        />
      ))}
    </div>
  );
};

export default IntervalSelector;
